import { request, requestBlob } from "../../../app/api-client/ApiClient";

/**
 * Metodo para obtener las maquinas asocuadas a un admin
 * @param {Integer} idAdmin 
 */
export function getlist(dispatch, filter, page, size) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/evbi/list/all?filter=${filter}&client=0&page=${page}&size=${size}`,
		method: "GET",
	}, dispatch);
}
export function getModulos(dispatch, idEvbi) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/modulos/list/evbi/${idEvbi}`,
		method: "GET",
	}, dispatch);
}
export function getModulosGenerales() {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/modulos/list/all`,
		method: "GET",
	},);
}
export function reassignEvbi(dispatch, idModule, idEvbi) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/modulos/asginar/evbi/${idModule}/${idEvbi}`,
		method: "GET",
	}, dispatch);
}

export function getlisthash(dispatch, hash, name, page, size) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/evbi/list/admin/hash/${hash}?name=${name}&page=${page}&size=${size}`,
		method: "GET",
	}, dispatch);
}


export function getlistid(dispatch, filter, id, page, size) {

	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/evbi/list/all?filter=${filter}&client=${id}&page=${page}&size=${size}`,
		method: "GET",
	}, dispatch);
}

export function updateEvbi(dispatch, Request) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/evbi/actualizar`;
	return request({
		url: url,
		method: "PUT",
		body: JSON.stringify(Request),
	}, dispatch);
}

export function getInformeMes(dispatch, userId) {
	return request({
		url: `${process.env.REACT_APP_API_EVBI}/v1/data/evbi/informe/mes/usuario/${userId}`,
		method: "GET",
	}, dispatch);
}

export function exportInformeMesCsv(dispatch, userId) {
	return requestBlob({
		url: `${process.env.REACT_APP_API_EVBI}/v1/data/export/report/informe/user/${userId}`,
		method: "GET",
	}, dispatch);
}

///multifiltro

export function getUsuariosMulti(dispatch, Request) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/data/evbi/user/multifilter/paged`;
	return request({
		url: url,
		method: "POST",
		body: JSON.stringify(Request),
	}, dispatch);
}

//mediciones manuales
export function crearOximetria(dispatch, Request) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/oximetria/create`;
	return request({
		url: url,
		method: "POST",
		body: JSON.stringify(Request),
	}, dispatch);
}
export function crearCapacidad(dispatch, Request) {
	let url = `${process.env.REACT_APP_API_EVBI}/v1/espirometria/create`;
	return request({
		url: url,
		method: "POST",
		body: JSON.stringify(Request),
	}, dispatch);
}


